import React, { Component } from 'react';
import cx from 'classnames';

class LoadingComponentMyTrips extends Component {
  static defaultProps = {
    filledWhite: false,
    round: false,
    isVoucher: false,
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      className,
      filledWhite,
      round,
      isGray,
      isVoucher,
    } = this.props;

    const loadingClasses = cx({
      'LoadingComponentMyTrips': true,
      'LoadingComponentMyTrips--round': round,
      'LoadingComponentMyTrips--filledWhite': filledWhite,
      'LoadingComponentMyTrips--Details-trip': isGray,
      'LoadingComponentMyTrips--Voucher': isVoucher,
    }, className);

    return (
      <div className={ loadingClasses }>
        <div className='LoadingComponentMyTrips-loader'>Loading...</div>
        <div className='LoadingComponentMyTrips-loader' />
        <div className='LoadingComponentMyTrips-loader' />
      </div>
    );
  }
}

export default LoadingComponentMyTrips;
